export const getInitialsName = (name: string) => {
  return name
    .split(" ")
    .map((name) => name[0])
    .slice(0, 2)
    .join("")
    .toUpperCase()
}
